import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class RightArrowIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 20 20"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601 C19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6S5.802,2.4,10,2.4c4.197,0,7.601,3.402,7.601,7.6 S14.197,17.599,10,17.599z"
					style={{
						fill: this.props.color,
						stroke: "#000000",
						fillOpacity: 0.5,
						strokeWidth: 1,
						strokeOpacity: 1
					}}/>
				<path
					d="M 4,8.6 L 12.25,8.6 9.75,6 11.25,4.5 16,10 11.25,15.5 9.75,14 12.25,11.4 4,11.4 4,8.6 Z"
					style={{
						fill: this.props.color,
						stroke: "#000000",
						fillOpacity: 0.5,
						strokeWidth: 1,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}